var exports = {
  "az": "Box__FxCigD",
  "uO": "StateLabel__8DRDjT",
  "EY": "Text__UCLECO",
};

module.exports = exports;
